import { useEffect, useState } from 'react';
import { playerUrl, wcPlayerUrl } from './assetUrls';

/**
 * Pick a player's photo for the competition being shown.
 *   International comp → WC photo, falling back to the club photo.
 *   Club comp          → club photo, falling back to the WC photo.
 * Returns { src, isWcImg } once an image has loaded, or src=null if neither exists.
 */
export function usePlayerPhoto(playerId, preferWc) {
    const [photo, setPhoto] = useState({ src: null, isWcImg: false });

    useEffect(() => {
        setPhoto({ src: null, isWcImg: false });
        if (!playerId || playerId === '0') return undefined;

        const club = { src: playerUrl(playerId), isWcImg: false };
        const wc   = { src: wcPlayerUrl(playerId), isWcImg: true };
        const candidates = preferWc ? [wc, club] : [club, wc];

        let cancelled = false;
        const tryLoad = (i) => {
            if (cancelled || i >= candidates.length) return;
            const img = new Image();
            img.onload  = () => { if (!cancelled) setPhoto(candidates[i]); };
            img.onerror = () => tryLoad(i + 1);
            img.src = candidates[i].src;
        };
        tryLoad(0);
        return () => { cancelled = true; };
    }, [playerId, preferWc]);

    return photo;
}
